import { useLocation } from "react-router";
import FranchiseContactUsList from "./components/FranchiseContactUsList";

export default function FranchiseCustomerContactUs() {
  const location = useLocation();
  
  return (
    <FranchiseContactUsList
      cityParam="skip others"
      deletePath="healthsy-pharmacy/franchise"
      pagePath="/franchise-programme/contact-us"
      breadcrumbSecond="Contact Us"
    />
  );
}
